import { Avatar } from "@portal/BaseComponents/Avatar/AntAvatar";
import { Button } from "@portal/BaseComponents/Button/AntButton";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { ImageComponent } from "@portal/BaseComponents/Image/AntImage";
import { Header } from "@portal/BaseComponents/Layout/AntLayout";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { logOut } from "@portal/api/login";
import { Icon } from "@portal/lib/icons/icons";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { Style } from "@portal/lib/style/style";
import { authAtom } from "@portal/store/auth/auth";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { sessionStore } from "@portal/util/browser-storage";
import { useAtomValue, useSetAtom } from "jotai";

const StyledImage = Style(ImageComponent, {});

const avatarStyles: React.CSSProperties = {
  width: "40px",
  height: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

function PageHeader() {
  const setAuth = useSetAtom(authAtom);
  const navigate = usePageNavigate();
  const config = useAtomValue(userConfigAtom);
  function handleLogOut() {
    logOut()
      .then(() => {
        setAuth({ authStatus: "not-authenticated" });
        navigate({ appPage: "LOGIN" });
        sessionStore.clear();
      })
      .catch();
  }
  const LogOutIcon = (
    <Icon
      icon={["far", "arrow-right-from-bracket"]}
      color="var(--gray-9)"
      fontSize={14}
    />
  );

  const UserName = (
    <ToolTip
      title={`${config.user_details?.user.first_name}${config.user_details?.user.last_name}`}
    >
      <div>
        <Avatar.Names
          name={[
            config.user_details?.user.first_name ?? "",
            config.user_details?.user.last_name ?? "",
          ]}
          namesProps={{ style: avatarStyles }}
        />
      </div>
    </ToolTip>
  );

  const LogOutButton = (
    <ToolTip title="Log out">
      <Button
        icon={LogOutIcon}
        style={{ height: "40px", width: "38px" }}
        onClick={handleLogOut}
      />
    </ToolTip>
  );

  const Logo = (
    <StyledImage
      src={config.visualConfig.config?.logo_uri}
      preview={false}
      contextMenu="header-logo"
    />
  );

  const CompanyInfo = (
    <Flex vertical align="start" space="2">
      <TypographyText fs={"12"} style={{ color: "var(--gray-7)" }}>
        {config.visualConfig?.config?.company_name}
      </TypographyText>
      <TypographyText fs={"20"}>
        {config.visualConfig?.config?.portal_name}
      </TypographyText>
    </Flex>
  );
  const CompanyDetails = (
    <Flex align="center" space="24" justify="start">
      {Logo}
      {CompanyInfo}
    </Flex>
  );
  const ActionArea = (
    <Flex align="center" justify="center">
      {UserName}
      {LogOutButton}
    </Flex>
  );
  return (
    <Header
      style={{
        lineHeight: 0,
        paddingInline: "var(--space-24)",
        position: "sticky",
        top: 0,
        borderBottom: "1px solid var(--gray-5)",
      }}
    >
      <Flex justify="space-between" align="center" style={{ height: "100%" }}>
        {CompanyDetails}
        {ActionArea}
      </Flex>
    </Header>
  );
}

export { PageHeader };
